






































































import { CatalogueItemModel, PartyModel, WorkTaskModel, WorkTaskRuleModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { partiesStore } from '@/libs/parties/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { workTasksStore } from '@/libs/work-tasks/+state/store';
import { catalogueItemsStore } from '@/libs/catalogue-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { workTaskRulesStore } from '@/libs/work-task-rules/+state/store';
import WorkTaskRuleDialog from '@/libs/parties/components/WorkTaskRuleDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        WorkTaskRuleDialog
    }
})
export default class WorkTaskRuleCreateDialog extends Page {

    dialog = false;
    valid = true;
    saving = false;
    tableHeaders = [
        { text: "Název", value: "name", align: "left" },
        { text: "", value: "id", align: "right" }
    ];
    nameFilter: string | null = null;
    partyIdValue: string | null = null;
	allowChangeParty = true;

    @Prop() partyId!: string | null;
    @Prop({ default: false }) hideActive!: boolean;
    @Prop() party!: PartyModel | null | undefined;

    @Ref() workTaskRuleDialog!: WorkTaskRuleDialog;

    @Watch("partyIdValue")
    partyIdValueChanged (v: string | null) {
        this.partyIdValue = v;
        this.loadWorkTasks();
    }

    get loading () {
        return workTaskRulesStore.useGetter(CrudGetter.Pending, "WorkTaskRuleCreateDialog");
    }

    get catalogueItems(): CatalogueItemModel[] {
        const loading = workTaskRulesStore.useGetter(CrudGetter.Pending, "WorkTaskRuleCreateDialog");
        if (loading) {
            return [];
        }
        const rules = workTaskRulesStore.useGetter(CrudGetter.Data, "WorkTaskRuleCreateDialog") as WorkTaskRuleModel[];
        let catalogueItems = catalogueItemsStore.useGetter(CrudGetter.Data) as CatalogueItemModel[];
        if (this.nameFilter && this.nameFilter.length > 0) {
            catalogueItems = catalogueItems.where(x => (x.name ?? "").toString().toLowerCase().includes(this.nameFilter!.toLowerCase())).toArray();
        }
        let items = catalogueItems.orderBy(x => x.name).toArray().map((e: CatalogueItemModel) => {
            const n = {...e} as any;
            n.isAdded = rules.find(x => x.catalogueItemId == e.id) != null;
            return n;
        });
        if (this.hideActive) {
            items = items.where(x => !x.isAdded).toArray();
        }
        return items;
    }

    open (allowChangeParty = true) {
        this.dialog = true;
        this.partyIdValue = this.partyId;
		this.allowChangeParty = allowChangeParty;
        this.loadWorkTasks();
    }

    addClick (item: CatalogueItemModel) {
		if (this.party && this.allowChangeParty) {
            this.$emit("create", item.id);
        }
        else {
            this.close();
            this.workTaskRuleDialog.create(item.id!, this.partyIdValue!, false);
        }
    }

    close () {
        this.dialog = false;
    }

    createWorkTaskRule () {
        this.workTaskRuleDialog.create("00000000-0000-0000-0000-000000000000", this.partyIdValue!, false);
    }

    loadWorkTasks () {
        workTaskRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>({
            field: "catalogueItem.name",
            index: 1,
            order: "asc"
        }, [
            {
                field: "partyId",
                op: "eq",
                comparand: this.partyIdValue ?? Guid.EmptyGuid()
            }
        ], undefined, false, "WorkTaskRuleCreateDialog"))
    }

}
